const API_URL = process.env.REACT_APP_API_URL;

class AppleAuthService {
  // Get the Apple Sign-In authorization URL (if you want to open in a new window)
  getAuthorizationUrl() {
    const clientId = "com.emotii.web"; // Replace with your client ID (Bundle ID)
    const redirectUri = API_URL + "api/v1/identity/sso/auth/apple/callback"; // Replace with your callback URL
    // const redirectUri =
    //   "https://10c6-86-123-159-250.ngrok-free.app/" +
    //   "api/v1/identity/sso/auth/apple/callback";
    const scope = "email"; // Define what data you want (name, email)
    const responseType = "code id_token"; // For authorization code and ID token
    const responseMode = "form_post"; // Apple will send the response as a POST request

    const url =
      `https://appleid.apple.com/auth/authorize?` +
      `response_type=${encodeURIComponent(responseType)}&` +
      `response_mode=${encodeURIComponent(responseMode)}&` +
      `client_id=${encodeURIComponent(clientId)}&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `scope=${encodeURIComponent(scope)}&`;

    return url;
  }
}

// Singleton instance of AppleAuthService
const appleAuthService = new AppleAuthService();
Object.freeze(appleAuthService); // Prevent modification of the singleton instance

export default appleAuthService;
